import { createAsyncReducer } from '../../standard-actions/reducers';
import {
    ILoadIPVoiceMergeTestIdAction,
    ILoadIPVoiceMergeTestIdSuccessAction,
    ILoadIPVoiceMergeTestIdErrorAction
} from '../actions/service/merge/load-merge-service-id-product-mapping';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';

export type IpVoiceMergeTestIdAction
    = ILoadIPVoiceMergeTestIdAction
    | ILoadIPVoiceMergeTestIdSuccessAction
    | ILoadIPVoiceMergeTestIdErrorAction;

const init = (state: ITicketsState, action: IpVoiceMergeTestIdAction) => ({
    ...state,
    ipVoiceMergeTestIdRequest: {
        ...initialState.ipVoiceMergeTestIdRequest,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: IpVoiceMergeTestIdAction) => ({
    ...state,
    ipVoiceMergeTestIdRequest: {
        ...initialState.ipVoiceMergeTestIdRequest,
        status: action.status,
        mergeTestId: (action as ILoadIPVoiceMergeTestIdSuccessAction).mergeTestId
    }
})

const failure = (state: ITicketsState, action: IpVoiceMergeTestIdAction) => ({
    ...state,
    ipVoiceMergeTestIdRequest: {
        ...initialState.ipVoiceMergeTestIdRequest,
        status: action.status,
        error: (action as ILoadIPVoiceMergeTestIdErrorAction).error
    }
});

export const ipVoiceMergeTestIdReducer = createAsyncReducer(initialState, init, success, failure);
